export default __webpack_public_path__ + "static/media/slide3.9f156bf5.jpg";